export function NotFound() {
  return (
    <div className="space-y-2 py-6">
      <h1 className="font-serif text-3xl">Not found</h1>
      <p className="text-text-secondary">No page at this URL.</p>
    </div>
  );
}
